"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
var _exportNames = {
  InfoHeader: true
};
exports.InfoHeader = void 0;

var _infoHeader = _interopRequireDefault(require("./components/info-header"));

exports.InfoHeader = _infoHeader["default"];

var _infoHeader2 = require("./components/info-header.propTypes");

Object.keys(_infoHeader2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _infoHeader2[key]) return;
  exports[key] = _infoHeader2[key];
});